<template>


    <div class="selector" :class="{ 'is-open': intolerancesOpen, 'has-selected-items': intolerancesSelected }">

        <!-- <h3>
            {{ filterResultsCount }} Ergebnisse
        </h3> -->

        <div class="native-scroll hide-scrollbars frame-breakout-h-medium">
            <div class="diets native-scroll__track frame-h-medium" :class="dietsClasses">
                <!-- TODO, passing state in multiple manners is fugly -->
                <Diet class="native-scroll__item" v-for="(item, index) in diets" :key="item.key" @select="selectDiet(index, item)" :data="item" />
            </div>
        </div>

        <div class="intolerances__wrapper" @clickaway="toggleIntolerances" :class="{ 'is-open': intolerancesOpen, 'has-selected-items': intolerancesSelected }">

            <div class="intolerances__header frame-2v-small" @click="toggleIntolerances">
                <!-- <h4 class="intolerances__title">{{ bclang('Haben Sie Unverträglichkeiten?') }}</h4> -->
                <h4 class="intolerances__title">{{ bclang('Filter ({0} ausgewählt)', selection.intolerances.length) }}</h4>
                <p class="intolerances__subtitle">
                    {{ bclang('{0} ausgewählt', selection.intolerances.length) }}
                </p>
                <!-- <button class="intolerances__toggle cross-button" :class="intolerancesOpen ? 'is-minus' : 'is-plus'">Toggle</button> -->

                <button class="intolerances__toggle hamburger hamburger--emphatic " :class="{ 'is-active': intolerancesOpen }" type="button"
                        aria-label="Menu" aria-controls="navigation" :aria-expanded="intolerancesOpen ? 'true' : 'false'">
                  <span class="hamburger-box">
                    <span class="hamburger-inner"></span>
                  </span>
                </button>
            </div>

            <div class="selector__filter" v-for="(filter, index) in filtersOrder" :key="index">

                <template v-if="filter == 'intolerances'">

                    <div v-if="intolerances" class="selector__grow-shrink ">

                        <h3 class="selector__headline">{{ bclang('Ohne Zusätze von', selection.intolerances.length, filteredIntolerances.length) }}</h3>

                        <div class="selector__intolerances-inner-wrapper intolerances__inner-wrapper">
                            <div class="selector__intolerances intolerances">
                                <Intolerance
                                    v-for="item in filteredIntolerances"
                                    :key="item.key"
                                    :data="item"
                                    @select="selectIntolerance(item)"
                                    @deselect="deselectIntolerance(item)"
                                />
                            </div>
                        </div>
                    </div>

                </template>

                <template v-if="filter == 'breadunits'">
                    <div v-if="show()" class="selector__grow-shrink frame-breakout-h-medium">
                        <div class="selector__sliders frame-h-medium">
                            <RangeSlider v-bind="ranges.breadUnits" :value="ranges.breadUnits.max" :headline="bclang('Broteinheiten')"
                                @change="sliderChange('breadUnits', $event)" />
                        </div>
                    </div>

                    <InfoBubble class="selector__filter-info selector__grow-shrink" @click.native="$emit('info', 'breadunits')" />

                </template>

                <template v-if="filter == 'kcals'">
                    <div v-if="show()" class="selector__grow-shrink frame-breakout-h-medium">
                        <div class="selector__sliders frame-h-medium">
                            <RangeSlider v-bind="ranges.kcals" :value="ranges.kcals.max" :headline="bclang('Kalorien')"
                                @change="sliderChange('kcals', $event)" />
                        </div>
                    </div>

                    <InfoBubble class="selector__filter-info selector__grow-shrink" @click.native="$emit('info', 'kcals')" />

                </template>

            </div>
            <button class="intolerances__submit button" @click="applyFilters">{{ bclang('Filter anwenden') }}</button>
        </div>
    </div>
</template>

<script>
import remove from 'lodash/remove';

// TODO: hotfix #1, this is all crap
let hasBeenShown = false;

export default {
    name: 'Selector',
    mounted() {
        this.initState();
    },
    methods: {
        initState() {
            this.selectDiet(0, this.diets[0]);
        },
        show() {
            // TODO: hotfix #1, this is all crap
            const show = this.ranges.breadUnits.max > 1;
            if (show && !hasBeenShown) {
                hasBeenShown = true;
                this.sliderChange('breadUnits', this.ranges.breadUnits.max);
                this.sliderChange('kcals', this.ranges.kcals.max);
            }
            return show;
        },
        sliderChange(name, val) {
            this.selection[name] = val;
            // this.$emit('change', this.selection);
        },
        selectDiet(index, item) {
            this.dietSelected = true;
            this.clearIntolerances();
            this.diets.forEach(diet => {
                diet.isActive = item === diet;
            });

            this.selection.diet = item;
            this.$emit('change', this.selection);
        },
        clearIntolerances() {
            (this.intolerances || []).forEach(int => {
                int.isActive = false;
            });
            this.selection.intolerances = [];
        },
        selectIntolerance(item) {
            this.selection.intolerances.push(item);
            // this.$emit('change', this.selection);
        },
        deselectIntolerance(item) {
            this.selection.intolerances = remove(this.selection.intolerances, i => i !== item);
            item.isActive = false;
            // this.$emit('change', this.selection);
        },
        applyFilters() {
            this.$emit('change', this.selection);
            this.toggleIntolerances();
        },
        toggleIntolerances() {
            this.intolerancesOpen = !this.intolerancesOpen;
        },
    },
    watch: {
        diets: function () {
            this.initState()
        },
    },
    computed: {
        intolerancesSelected() {
            return this.selection.intolerances.length;
        },
        filteredIntolerances() {
            // TODO: make this more readable?
            if (this.intolerances && this.intolerances.length && this.selection.diet) {
                return this.intolerances.filter(int => {
                    return this.selection.diet.inactiveIntolerances.indexOf(int) === -1;
                });
            } else {
                return this.intolerances;
            }
        },
        dietsClasses() {

            return {
                'is-overflow': this.diets.length > 3,
            }
        }
    },
    props: {
        ranges: {
            type: Object,
            default: () => ({
                breadUnits: {
                    min: 1,
                    max: 1,
                },
                kcals: {
                    min: 1,
                    max: 1,
                }
            })
        },
        diets: Array,
        intolerances: Array,
        filterResultsCount: Number,
        filtersOrder: Array,
    },
    data() {
        return {
            dietSelected: false,
            // intolerancesOpen: false,
            intolerancesOpen: false,
            selection: {
                breadUnits: this.ranges.breadUnits.max,
                kcals: this.ranges.kcals.max,
                intolerances: [],
                diet: null
            },
        };
    },
}
</script>

<style lang="scss">

@import '../scss/config';

$hamburger-padding-x           : rem(15);
$hamburger-padding-y           : rem(15);
$hamburger-layer-width         : rem(22);
$hamburger-layer-height        : size(line);
$hamburger-layer-spacing       : rem(4);
$hamburger-layer-color         : color(middleground);
$hamburger-layer-border-radius : rem(0);
$hamburger-hover-opacity       : 1;
$hamburger-active-layer-color  : color(foreground);
$hamburger-active-hover-opacity: $hamburger-hover-opacity;
$hamburger-hover-use-filter    : false;
$hamburger-hover-filter        : opacity(50%);
$hamburger-active-hover-filter : $hamburger-hover-filter;
$hamburger-types: (
  emphatic,
  spin,
  emphatic-r,
);

@import "~hamburgers/_sass/hamburgers/hamburgers";

.selector {
    $parent: #{&};

    &__filter {
        // outline: 1px solid red;
        margin-bottom: 0;
        position: relative;

        h3 {
            margin-top: 0;
            color: color(accent);
            margin-bottom: size(medium);
        }

        .intolerances__wrapper.is-open & {
            margin-bottom: size(large);
        }
    }

    &__headline {
        @include font-regular();
        font-size: size(font-regular);
        line-height: 1;
    }

    &__filter-info {
        position: absolute;
        right: 0;
        top: 0;
    }

    &__grow-shrink {
        max-height: 0;
        transition: max-height 0.3s ease, opacity 0.3s ease;
        overflow: hidden;
        opacity: 0;

        #{$parent}.is-open & {
            max-height: rem(300);
            opacity: 1;
        }
    }
}
</style>
